// Mock data for Prime Auto Logix

export const businessInfo = {
  name: "Prime Auto Logix",
  tagline: "Detail. Upgrade. Connect.",
  phone: "6473261174",
  phoneFormatted: "(647) 326-1174",
  whatsapp: "6473261174",
  emails: {
    service: "info@primeautologix.ca",
    booking: "primeautologix@gmail.com"
  },
  address: {
    street: "48 Tamvale Crescent",
    city: "Kitchener",
    province: "ON",
    postalCode: "N2E 3K7",
    full: "48 Tamvale Crescent, Kitchener N2E 3K7 ON"
  },
  serviceAreas: ["Kitchener", "Waterloo", "Cambridge", "Guelph"],
  hours: {
    weekdays: "Monday - Friday: 7:00 AM - 7:00 PM",
    saturday: "Saturday: 7:00 AM - 6:00 PM",
    sunday: "Sunday: 7:00 AM - 5:00 PM"
  }
};

export const services = [
  {
    id: 1,
    name: "Auto Detailing",
    slug: "detailing",
    icon: "Sparkles",
    shortDescription: "Premium auto detailing in Kitchener-Waterloo that brings your vehicle back to showroom condition",
    description: "Professional auto detailing services in Kitchener, Waterloo, Cambridge, and Guelph. We use premium products and proven techniques to restore your car's beauty and protect its value. From interior deep cleaning to exterior paint correction, we meticulously care for every detail. Expert steam cleaning, leather conditioning, and multi-stage paint correction available.",
    features: [
      "Deep interior cleaning with steam treatment",
      "Exterior clay bar and hand polish",
      "Paint correction (1-stage or 2-stage)",
      "Engine bay and trunk detailing",
      "Leather and fabric conditioning",
      "Premium sealant and tire dressing"
    ],
    packages: [
      {
        name: "Basic Wash & Vac",
        price: "Sedan: $80-$120 | SUV: $100-$150",
        duration: "1-2 hours",
        includes: ["Exterior wash", "Interior vacuum", "Windows cleaned", "Tire dressing"]
      },
      {
        name: "Interior Detail",
        price: "Sedan: $150-$250 | SUV: $200-$300",
        duration: "2-3 hours",
        includes: ["Deep clean", "Leather/fabric treatment", "Dashboard & console", "Steam cleaning"]
      },
      {
        name: "Exterior Detail",
        price: "Sedan: $150-$250 | SUV: $200-$300",
        duration: "2-3 hours",
        includes: ["Clay bar treatment", "Hand polish", "Sealant application", "Wheel detail", "Trim restoration"]
      },
      {
        name: "Full Detail",
        price: "Sedan: $300-$500 | SUV: $400-$600",
        duration: "4-6 hours",
        includes: ["Complete interior + exterior", "Engine bay cleaning", "Trunk detailing", "Premium finish"]
      },
      {
        name: "Paint Correction (1-stage)",
        price: "Sedan: $350-$550 | SUV: $450-$650",
        duration: "1 day",
        includes: ["Removes light swirls", "Polishing treatment", "Surface preparation", "Protective sealant"]
      },
      {
        name: "Paint Correction (2-stage)",
        price: "Sedan: $550-$800 | SUV: $650-$1,000",
        duration: "1-2 days",
        includes: ["Compound & polish", "Moderate to heavy defect correction", "Multi-step process", "Premium protection"]
      }
    ]
  },
  {
    id: 2,
    name: "Ceramic Coating",
    slug: "ceramic-coating",
    icon: "Shield",
    shortDescription: "Protect your investment with a durable ceramic coating in Waterloo - advanced 9H ceramic coatings for unmatched gloss and protection",
    description: "Premium ceramic coating services in Kitchener, Waterloo, Cambridge and Guelph. Our Gtechniq-certified installers apply advanced 9H ceramic coatings for unmatched gloss, scratch resistance, and hydrophobic properties. Choose from our Bronze, Silver, and Gold packages for long-lasting paint protection.",
    features: [
      "Gtechniq 9H multi-layer ceramic coating",
      "Hydrophobic properties - water beads off instantly",
      "UV protection prevents paint fading",
      "Scratch and swirl mark resistance",
      "Chemical resistant barrier",
      "1-5 year protection depending on package"
    ],
    packages: [
      {
        name: "Bronze (Entry)",
        price: "$500 - $800",
        duration: "1 day",
        includes: ["1-stage paint correction", "Single layer ceramic", "Wheels coated", "Glass coating", "1-year protection"]
      },
      {
        name: "Silver (Standard)",
        price: "$900 - $1,500",
        duration: "1-2 days",
        includes: ["2-stage paint correction", "Multi-layer ceramic", "Trim, wheels, glass coating", "3-year protection", "Maintenance kit"]
      },
      {
        name: "Gold (Premium)",
        price: "$1,500 - $2,500",
        duration: "2-3 days",
        includes: ["Full paint correction", "4+ layers 9H ceramic", "All exterior surfaces", "Leather/fabric interior coating", "5-year protection"]
      },
      {
        name: "Maintenance Wash",
        price: "$80 - $120",
        duration: "1 hour",
        includes: ["pH-neutral wash", "Ceramic booster application", "Full inspection", "Touch-up as needed"]
      }
    ]
  },
  {
    id: 3,
    name: "Paint Protection Film (PPF)",
    slug: "ppf",
    icon: "ShieldCheck",
    shortDescription: "Shield your car from chips and scratches with premium Paint Protection Film (PPF) in Guelph - Xpel and 3M PPF installation",
    description: "Premium Paint Protection Film (PPF) installation in Kitchener-Waterloo using Xpel Ultimate Plus and 3M Scotchgard Pro Series. Safeguard against stone chips, scratches, and swirl marks with self-healing technology. Perfect for new car owners and luxury vehicles. Preserve your vehicle's pristine finish with our expert installation and 10-year manufacturer warranty.",
    features: [
      "Xpel Ultimate Plus & 3M Scotchgard Pro Series",
      "10-year manufacturer warranty",
      "Invisible protection - maintains original look",
      "Self-healing technology for minor scratches",
      "Stain and yellowing resistant",
      "Professional installation by certified technicians"
    ],
    packages: [
      {
        name: "Partial Front",
        price: "$650 - $1,200",
        duration: "4-6 hours",
        includes: ["Partial hood (18\")", "Fenders", "Mirrors", "Headlights", "Door cups", "10-year warranty"]
      },
      {
        name: "Full Front",
        price: "$1,400 - $2,500",
        duration: "1-2 days",
        includes: ["Full hood", "Full fenders", "Full bumper", "Mirrors", "Headlights", "A-pillars", "Rocker panels", "10-year warranty"]
      },
      {
        name: "Track Pack",
        price: "$2,500 - $3,500",
        duration: "2-3 days",
        includes: ["Full front coverage", "Rocker panels", "Rear bumper", "Door edges", "Trunk edge", "Performance vehicle optimization", "10-year warranty"]
      },
      {
        name: "Full Body",
        price: "$4,500 - $7,000+",
        duration: "5-7 days",
        includes: ["Complete vehicle coverage", "All painted surfaces", "Door jambs", "Premium finish", "Lifetime workmanship guarantee", "10-year warranty"]
      }
    ]
  },
  {
    id: 4,
    name: "Vinyl Wraps",
    slug: "vinyl-wraps",
    icon: "Palette",
    shortDescription: "Transform your vehicle with custom vinyl wraps in Cambridge - colour changes, specialty finishes, and commercial fleet wrapping",
    description: "Professional vinyl wrap installation in Kitchener, Waterloo, and Cambridge. Transform your vehicle's appearance with custom colour changes, specialty finishes (matte, satin, chrome, color-flip), or commercial fleet branding. Premium 3M and Avery Dennison films with durability and expert installation.",
    features: [
      "3M and Avery Dennison premium films",
      "Full colour change or accent wraps",
      "Matte, gloss, satin, chrome, and specialty finishes",
      "Paint protection during installation",
      "Removable without damage to original paint",
      "Commercial fleet volume pricing available"
    ],
    packages: [
      {
        name: "Full Colour Change (Sedan)",
        price: "$2,500 - $4,000",
        duration: "3-5 days",
        includes: ["Gloss, matte, or satin finish", "Complete vehicle wrap", "Disassembly & reassembly", "Post-heat treatment", "Professional installation"]
      },
      {
        name: "Full Colour Change (SUV/Truck)",
        price: "$3,500 - $6,000",
        duration: "4-6 days",
        includes: ["Full coverage with complex panel management", "Premium materials", "Door jambs wrapped", "Professional installation"]
      },
      {
        name: "Specialty Finish",
        price: "$5,000 - $8,000+",
        duration: "5-7 days",
        includes: ["Chrome or color-flip finish", "Premium materials", "Complex curves handled", "Expert installation", "Show-quality finish"]
      },
      {
        name: "Partial/Accents",
        price: "$500 - $1,500",
        duration: "1-2 days",
        includes: ["Roof, hood, or accent pieces", "Racing stripes", "Chrome delete", "Custom patterns", "Two-tone designs"]
      },
      {
        name: "Commercial/Fleet",
        price: "Custom Quote",
        duration: "Varies",
        includes: ["Business branding", "Logo application", "Fleet vehicle graphics", "Volume pricing", "Fast turnaround"]
      }
    ]
  },
  {
    id: 5,
    name: "Window Tinting",
    slug: "tinting",
    icon: "Sun",
    shortDescription: "Professional window tinting in KW - UV protection, heat rejection, and privacy with MTO compliant films",
    description: "Enhance your vehicle's comfort and style with professional window tinting in Kitchener. Prime Auto Logix offers a range of high-performance ceramic, carbon, and dyed window films to block heat, reduce glare, and protect your privacy. All installations are MTO compliant with lifetime warranties on ceramic and carbon films.",
    features: [
      "99% UV ray protection",
      "Heat rejection technology",
      "Lifetime warranty on ceramic & carbon films",
      "3-year warranty on dyed films",
      "Multiple shade and film type options",
      "Ontario MTO compliant (70% VLT front side windows)"
    ],
    packages: [
      {
        name: "Dyed Film",
        price: "Sedan: $200-$300 | SUV: $250-$400",
        duration: "2-3 hours",
        includes: ["All side windows", "3-year warranty", "Standard heat rejection", "Professional installation", "Front 2 windows: $120-$150"]
      },
      {
        name: "Carbon Film",
        price: "Sedan: $300-$450 | SUV: $350-$500",
        duration: "3-4 hours",
        includes: ["All windows", "Lifetime warranty", "Superior heat rejection", "Non-metallic construction", "Front 2 windows: $150-$200"]
      },
      {
        name: "Ceramic Film",
        price: "Sedan: $380-$600 | SUV: $430-$700",
        duration: "3-4 hours",
        includes: ["All windows", "Lifetime warranty", "Maximum heat rejection", "Premium clarity", "Signal-friendly", "Front 2 windows: $200-$300"]
      },
      {
        name: "Windshield Strip",
        price: "$50 - $100",
        duration: "30 minutes",
        includes: ["Top windshield tint strip", "Lifetime warranty", "Glare reduction", "Professional installation"]
      }
    ]
  },
  {
    id: 6,
    name: "Apple CarPlay / Android Auto Installation",
    slug: "carplay",
    icon: "Smartphone",
    shortDescription: "Upgrade your driving experience with seamless CarPlay and Android Auto installation in Kitchener-Waterloo",
    description: "Upgrade your driving experience with modern connectivity. Prime Auto Logix specializes in wireless CarPlay adapters and full infotainment system upgrades to bring modern connectivity to your vehicle. Stay connected, navigate easily, and enjoy your music with our expert tech solutions and OEM-quality integration.",
    features: [
      "Wireless and wired CarPlay/Android Auto options",
      "OEM-quality integration",
      "Steering wheel control retention",
      "Backup camera compatible",
      "Voice command support",
      "Professional wire hiding and installation"
    ],
    packages: [
      {
        name: "Wired CarPlay Retrofit",
        price: "$300 - $600",
        duration: "2-4 hours",
        includes: ["Aftermarket head unit or OEM module", "Professional wiring", "System testing", "1-year warranty"]
      },
      {
        name: "Wireless CarPlay Upgrade",
        price: "$150 - $350",
        duration: "1-2 hours",
        includes: ["Wireless adapter for existing wired CarPlay", "Plug-and-play installation", "System configuration", "1-year warranty"]
      },
      {
        name: "Full Infotainment System",
        price: "$800 - $1,500",
        duration: "4-6 hours",
        includes: ["Premium touchscreen head unit", "CarPlay/Android Auto", "Backup camera integration", "Steering wheel controls", "Complete dash kit", "2-year warranty"]
      }
    ]
  },
  {
    id: 7,
    name: "Vehicle Gadgets & Accessories",
    slug: "gadgets",
    icon: "Settings",
    shortDescription: "Enhance your vehicle with cameras, speakers, alloy wheels, and premium accessories",
    description: "Complete your vehicle upgrade with our selection of premium gadgets and accessories. From safety features to style enhancements, we offer professional installation of dash cams, speaker systems, wheels, and LED lighting to elevate your ownership experience.",
    features: [
      "Front and rear dash cameras",
      "Premium speaker system upgrades",
      "Custom alloy wheel packages",
      "Dash cameras with parking mode",
      "Subwoofer and amplifier installation",
      "LED interior and exterior lighting"
    ],
    packages: [
      {
        name: "Dash Cam (Front)",
        price: "$200 - $400",
        duration: "1-2 hours",
        includes: ["Supply + professional installation", "Hardwired or plug-in option", "Setup and testing", "1-year warranty"]
      },
      {
        name: "Dash Cam (Front + Rear)",
        price: "$350 - $600",
        duration: "2-3 hours",
        includes: ["Front and rear cameras", "Professional hardwiring", "Parking mode setup", "1-year warranty"]
      },
      {
        name: "Speaker Upgrade",
        price: "$300 - $800",
        duration: "2-4 hours",
        includes: ["Component speaker installation", "Sound optimization", "Professional wiring", "1-year warranty"]
      },
      {
        name: "Subwoofer & Amplifier",
        price: "$500 - $1,200",
        duration: "3-5 hours",
        includes: ["Subwoofer and amp installation", "Custom enclosure option", "Professional wiring", "Sound tuning", "1-year warranty"]
      },
      {
        name: "Wheel Packages",
        price: "$1,200 - $4,000+",
        duration: "1-2 hours",
        includes: ["Set of 4 alloy wheels", "Professional mounting", "Balancing", "TPMS transfer"]
      },
      {
        name: "LED Lighting",
        price: "$100 - $400",
        duration: "1-2 hours",
        includes: ["Interior or exterior LED installation", "Custom colour options", "Professional wiring", "1-year warranty"]
      }
    ]
  }
];

export const bundlePackages = [
  {
    id: 1,
    name: "New Car Protection Bundle",
    slug: "new-car-protection",
    description: "The ultimate protection package for your new vehicle investment",
    price: "$3,200 - $5,500",
    savings: "~12% vs. à la carte",
    includes: [
      "Ceramic window tint (full vehicle)",
      "Gold ceramic coating package",
      "Full front PPF coverage"
    ],
    ideal: "New car owners seeking maximum protection"
  },
  {
    id: 2,
    name: "Full Transformation Bundle",
    slug: "full-transformation",
    description: "Complete makeover combining protection, style, and showroom finish",
    price: "$3,800 - $6,500",
    savings: "~15% vs. à la carte",
    includes: [
      "Full colour-change vinyl wrap",
      "Ceramic window tint (full vehicle)",
      "Full detail with paint correction"
    ],
    ideal: "Enthusiasts wanting a complete vehicle transformation"
  },
  {
    id: 3,
    name: "Tech Upgrade Bundle",
    slug: "tech-upgrade",
    description: "Modern connectivity and safety features in one convenient package",
    price: "$800 - $1,500",
    savings: "~10% vs. à la carte",
    includes: [
      "Wireless CarPlay/Android Auto installation",
      "Dual dash cam (front + rear)",
      "Speaker upgrade package"
    ],
    ideal: "Tech-savvy drivers modernizing older vehicles"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Thompson",
    location: "Kitchener, ON",
    rating: 5,
    service: "Auto Detailing",
    text: "Incredible attention to detail! My car looks brand new after their premium detailing service. The team at Prime Auto Logix really knows what they're doing.",
    date: "2024-11-15"
  },
  {
    id: 2,
    name: "Sarah Chen",
    location: "Waterloo, ON",
    rating: 5,
    service: "Window Tinting",
    text: "Best tinting job I've ever had. The ceramic film keeps my car so much cooler in summer. Professional service from start to finish!",
    date: "2024-10-28"
  },
  {
    id: 3,
    name: "David Patterson",
    location: "Cambridge, ON",
    rating: 5,
    service: "CarPlay Installation",
    text: "The CarPlay installation was seamless. They made it look factory-installed. Love having wireless connectivity in my older vehicle!",
    date: "2024-11-02"
  },
  {
    id: 4,
    name: "Jennifer Rodriguez",
    location: "Guelph, ON",
    rating: 5,
    service: "Vehicle Gadgets",
    text: "Had dash cam and reverse camera installed. Feel so much safer now! Installation was clean and professional. Highly recommend!",
    date: "2024-10-19"
  },
  {
    id: 5,
    name: "Robert Kumar",
    location: "Kitchener, ON",
    rating: 5,
    service: "Auto Detailing",
    text: "Worth every penny! The ultimate detail package brought my 5-year-old car back to life. Amazing transformation!",
    date: "2024-11-08"
  },
  {
    id: 6,
    name: "Amanda Wilson",
    location: "Waterloo, ON",
    rating: 5,
    service: "Complete Services",
    text: "Used them for tinting and audio upgrade. Outstanding quality and customer service. These guys are the best in the region!",
    date: "2024-10-25"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1770700391793-22fc46041c2b",
    alt: "Blue car with water droplets showing professional detailing process",
    category: "detailing",
    title: "Premium Exterior Detail"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1647844870489-1966c5000382",
    alt: "Car in professional garage setting during service",
    category: "detailing",
    title: "Professional Service Environment"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1647844850804-7199e36a78c0",
    alt: "Red car in professional garage undergoing detailing",
    category: "detailing",
    title: "Expert Care & Attention"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/15579395/pexels-photo-15579395.jpeg",
    alt: "Classic red car with foam wash treatment",
    category: "detailing",
    title: "Deep Clean Treatment"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1646531840695-62810bcd1171",
    alt: "Professional technician working on orange car",
    category: "service",
    title: "Expert Technicians at Work"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1646531839801-7d0010d7513a",
    alt: "Yellow truck in professional garage facility",
    category: "service",
    title: "All Vehicle Types Welcome"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1550675068-4f037e85d412",
    alt: "White BMW with professional finish after detailing",
    category: "detailing",
    title: "Showroom Quality Results"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1646531839844-034be6a06aad",
    alt: "Professional garage with multiple vehicles being serviced",
    category: "service",
    title: "State-of-the-Art Facility"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1656077917362-328d7ba235ae",
    alt: "White sports car receiving detail work",
    category: "detailing",
    title: "Precision Detail Work"
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1656077917400-a955ba30cfe5",
    alt: "Car interior detailing and cleaning",
    category: "interior",
    title: "Interior Deep Clean"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1614888441158-de25f0ea4bc5",
    alt: "Professional working on red car detailing",
    category: "detailing",
    title: "Meticulous Attention"
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1771491237218-cbd4a707497e",
    alt: "Dashboard cleaning and interior detail work",
    category: "interior",
    title: "Dashboard Restoration"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does a full detail take?",
    answer: "Depending on the package, a full detail can take anywhere from 2-3 hours for a basic detail to a full day for our ultimate package with paint correction and ceramic coating."
  },
  {
    id: 2,
    question: "Is window tinting legal in Ontario?",
    answer: "Yes! We ensure all our tinting complies with Ontario regulations. Front side windows must allow at least 70% light transmission, while rear windows can be darker. We'll help you choose the right shade."
  },
  {
    id: 3,
    question: "Will CarPlay work with my older vehicle?",
    answer: "Absolutely! We can install CarPlay/Android Auto in virtually any vehicle. Our systems integrate seamlessly and often retain your factory steering wheel controls."
  },
  {
    id: 4,
    question: "Do you offer mobile service?",
    answer: "For certain services like detailing, we can come to you! Contact us via WhatsApp or phone to discuss mobile service availability in Kitchener, Waterloo, Cambridge, and Guelph."
  },
  {
    id: 5,
    question: "What payment methods do you accept?",
    answer: "We accept cash, debit, all major credit cards, and e-transfer. Payment is due upon completion of service."
  },
  {
    id: 6,
    question: "Do you provide warranties?",
    answer: "Yes! All our services come with warranties. Detailing ceramic coatings have up to 5-year warranties, window tinting includes lifetime warranties, and electronic installations come with 1-2 year warranties depending on the package."
  }
];

// Form submission mock handler
export const submitInquiryForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submission (MOCKED):", formData);
      localStorage.setItem('lastInquiry', JSON.stringify({
        ...formData,
        timestamp: new Date().toISOString()
      }));
      resolve({
        success: true,
        message: "Thank you! We've received your inquiry and will contact you soon.",
        mockNote: "This is currently using mock data. Backend integration pending."
      });
    }, 1000);
  });
};
